import {
	Button,
	IconButton,
	Table,
	TableBody,
	TableCell, TableContainer,
	TableHead,
	TableRow,
	Tooltip, Typography
} from "@mui/material"
import {
	MoreHoriz,
} from "@mui/icons-material"
import WorkspacePermissionsIcons from "./WorkspacePermissionsIcons"
import {useState} from "react"
import {useDispatch, useSelector} from "react-redux"
import {
	selectTargetUser, setManageWorkspaceError, setManageWorkspaceMessage,
	setTargetUser,
} from "../../../reducers/manageWorkspaceSlice"
import {selectWorkspacePermissions} from "../../../reducers/workspaceSlice"
import {selectUser} from "../../../reducers/userSlice"
import {InviteManagementMenu, UserManagementMenu} from "./ManagementMenus"
import {useWorkspaceContext} from "../../../pages/Dashboard"

export default function ListOfUsers({members, displayingInvites}) {
	const dispatch = useDispatch()
	const { workspaceId } = useWorkspaceContext()
	const [isOpen, setIsOpen] = useState(false)
	const [anchorEl, setAnchorEl] = useState(null)
	const targetMember = useSelector(selectTargetUser)
	const currentUser = useSelector(selectUser)
	const workspacePermissions = useSelector((state) => selectWorkspacePermissions(state, workspaceId))

	const handleMenuOpen = async (e, member) => {
		setAnchorEl(e.currentTarget)
		if(!displayingInvites) {
			await dispatch(setTargetUser(member))
		} else {
			const fakeUserObject = {
				user: {
					firstName: "Invite",
					lastName: "Author",
					email: member.invite.inviteEmail,
					id: -1,
					invite: member.invite
				},
				workspacePermissions: member.workspacePermissions,
				selectedNoteIds: member.noteRestrictions
			}
			await dispatch(setTargetUser(fakeUserObject))
		}
		setIsOpen(true)
	}

	const copyInviteCode = (code) => {
		navigator.clipboard
			.writeText(code)
			.then(() => {
				dispatch(setManageWorkspaceMessage("Author invite copied to clipboard"))
			})
			.catch((e) => {
				console.error ("ERROR WRITING LINK TO CLIPBOARD: ", e)
				dispatch(setManageWorkspaceError("Failed to copy author invite link"))
			})
	}

	const statusToText = (statusEnumValue) => {
		return statusEnumValue === "USED_AUTHOR" ? "USED" : "CREATED"
	}

	return (
		<TableContainer sx={{height:"100%"}}>
			<Table stickyHeader size={"small"}>
				<TableHead>
					<TableRow>
						<TableCell>{displayingInvites ? "E-mail" : "Name"}</TableCell>
						{displayingInvites &&
							(<TableCell>Invite Code</TableCell>)
						}
						{displayingInvites &&
							(<TableCell>Status</TableCell>)
						}
						<TableCell>Workspace Permissions</TableCell>
						<TableCell /> {/* blank to make room for button */}
					</TableRow>
				</TableHead>
				<TableBody>
					{ members.map(member => (
						<TableRow
							key={ displayingInvites ? member.invite.id : member.user.id}
							sx={{
								"&:hover": {
									backgroundColor: "action.focus"
								},
							}}
						>
							{member.user &&
								<TableCell>
									{member.user.firstName + " " + member.user.lastName}
								</TableCell>
							}
							{member.invite &&
								<>
									<TableCell>
										{member.invite.inviteEmail}
									</TableCell>
									<TableCell>
										<Tooltip title={"Click to copy code"}>
											<Button
												variant={"contained"}
												size={"small"}
												onClick={() => copyInviteCode(member.invite.UUID)}
											>
												<Typography
													sx={{
														width: "10rem",
														maxWidth: "10rem",
														whiteSpace: "nowrap",
														overflow: "hidden",
														textOverflow: "ellipsis",
														cursor: "pointer"
													}}
												>
													{member.invite.UUID}
												</Typography>
											</Button>
										</Tooltip>
									</TableCell>
									<TableCell>
										{statusToText(member.invite.status)}
									</TableCell>
								</>
							}
							<TableCell>
								<WorkspacePermissionsIcons workspacePermissions={member.workspacePermissions}/>
							</TableCell>
							{ workspacePermissions.admin &&
								<TableCell>
									<Tooltip title={currentUser.id === member.user?.id ? "You cannot modify your own settings" : "Change this user's permissions in this Workspace"} placement={"right"}>
										<span>
											<IconButton
												variant={"curved-square"}
												onClick={(e) => handleMenuOpen(e, member)}
												disabled={currentUser.id === member.user?.id} // disable the menu for yourself
											>
												<MoreHoriz />
											</IconButton>
										</span>
									</Tooltip>
									{targetMember !== null && !displayingInvites ?
										(<UserManagementMenu
											isOpen={isOpen}
											setIsOpen={setIsOpen}
											anchorEl={anchorEl}
											member={targetMember}
											currentUser={currentUser}
										/>)
										:
										(<InviteManagementMenu
											isOpen={isOpen}
											setIsOpen={setIsOpen}
											anchorEl={anchorEl}
											member={targetMember}
										/>)
									}
								</TableCell>
							}
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	)
}

